import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)
//
let actions = {
  login: { // 用户登录
    'method': 'POST',
    'url': '/api/v1/auth/login'
  },
  complete: { // 用户注册
    'method': 'put',
    'url': '/api/v1/users/'
  },
  session: { // 获取用户信息
    'method': 'GET',
    'url': '/api/v1/auth/session'
  },
  indicators: {
    'method': 'GET',
    'url': '/api/v1/users/indicators'
  },
  tags: {
    'method': 'GET',
    'url': '/api/v1/users/tags'
  },
  records: { // 我的测评
    method: 'GET',
    'url': '/api/v1/users/my_records'
  },
  report: { // 我的测评
    method: 'GET',
    'url': '/api/v1/users/report'
  }
}

export default Vue.resource('/api/v1/users/:id', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/user.js